var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247,
    height: 247,
    viewBox: "0 0 247 247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_197_1",
    "data-name": "Component 197 \\u2013 1",
    transform: "translate(4.5 4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_27",
    "data-name": "Subtraction 27",
    d: "M8430,7560a119,119,0,1,1-119,119A119,119,0,0,1,8430,7560Z",
    transform: "translate(-8311 -7560)",
    fill: "none",
    stroke: "#77406f",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_106386",
    "data-name": "Group 106386",
    transform: "translate(59.965 74.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69872",
    "data-name": "Path 69872",
    d: "M240.1,354.421a7.458,7.458,0,0,1-5.257-2.168c-22.452-22.452-61.566-22.452-84,0a7.424,7.424,0,0,1-10.5-10.5,74.227,74.227,0,0,1,105,0,7.43,7.43,0,0,1,0,10.5A7.336,7.336,0,0,1,240.1,354.421Z",
    transform: "translate(-133.82 -245.328)",
    fill: "#77406f",
    stroke: "#f4f4f4",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9630",
    "data-name": "Ellipse 9630",
    cx: 14.5,
    cy: 15,
    rx: 14.5,
    ry: 15,
    transform: "translate(0.035 -0.034)",
    fill: "#77406f",
    stroke: "#f4f4f4",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9631",
    "data-name": "Ellipse 9631",
    cx: 14.5,
    cy: 15,
    rx: 14.5,
    ry: 15,
    transform: "translate(89.035 -0.034)",
    fill: "#77406f",
    stroke: "#f4f4f4",
    strokeWidth: 6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkay);
export default __webpack_public_path__ + "static/media/okay.3d29d2cc5e175d18494b8f07df02e5ac.svg";
export { ForwardRef as ReactComponent };